import React from 'react'
import './index.scss'
import Button from '@Components/Buttons/Button'
import { USER_VERIFICATION_STATUSES } from '@Const/user-statuses'
import { useNavigate } from 'react-router'

interface GetVerifiedPopupProps {
    onCloseConfirmPopup(): void
    clickEditProfile(): void
    status?: string | null
}

const GetVerifiedPopup = (props: GetVerifiedPopupProps) => {
    const { onCloseConfirmPopup, clickEditProfile, status } = props
    const navigate = useNavigate()
    const clickContactSupport = () => {
        navigate('/contact-us')
    }

    return (
        <div className="main-block">
            <div className="verified-popup">
                {status !== USER_VERIFICATION_STATUSES.REJECTED ? (
                    <>
                        <h1>You must complete your profile information first.</h1>

                        <p>
                            We verify your user information by running it through a &apos;Know Your Customer (KYC)&apos;
                            check. Please complete your profile information, then try again.
                        </p>

                        <div className="buttons">
                            <Button mainColor type="secondary" onClick={onCloseConfirmPopup}>
                                Cancel
                            </Button>
                            <Button mainColor type="primary" onClick={clickEditProfile}>
                                Edit My Profile
                            </Button>
                        </div>
                    </>
                ) : (
                    <>
                        <h1>Your account failed &apos;KYC&apos; verification</h1>

                        <p>
                            We verify your user information by running it through a &apos;Know Your Customer (KYC)&apos;
                            check. For one reason or another, your verification failed. Please contact support for
                            assistance.
                        </p>

                        <div className="buttons">
                            <Button mainColor type="secondary" onClick={onCloseConfirmPopup}>
                                Cancel
                            </Button>
                            <Button mainColor type="primary" onClick={clickContactSupport}>
                                Contact Support
                            </Button>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}
export default GetVerifiedPopup
